import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';

import { LocationResultsListsV2Locations } from '../../../../components';
import { type LocationResultsListsV2Props } from '../../../../LocationResultsListsV2.types';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationResultsListsV2Expanded = memo((props: LocationResultsListsV2ExpandedProps) => {
  const {
    locationSearchActorRef,
    variation,
    interactedLocationRestaurantSlug,
    interactedLocationDeliveryAddressId,
    onCollapse,
  } = props;

  return (
    <View style={styles.outerContainer}>
      <View style={styles.innerContainer}>
        <LocationResultsListsV2Locations
          locationSearchActorRef={locationSearchActorRef}
          variation={variation}
          interactedLocationDeliveryAddressId={interactedLocationDeliveryAddressId}
          interactedLocationRestaurantSlug={interactedLocationRestaurantSlug}
          onViewMapPress={onCollapse}
        />
      </View>
    </View>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
  },
  innerContainer: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LocationResultsListsV2ExpandedProps = {
  onCollapse: () => void;
} & Pick<
  LocationResultsListsV2Props,
  | 'locationSearchActorRef'
  | 'variation'
  | 'interactedLocationRestaurantSlug'
  | 'interactedLocationDeliveryAddressId'
>;
